// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__zBqwF","loader":"LoadingScreen_loader__ufTLp","spinner":"LoadingScreen_spinner__qUQyg","spin":"LoadingScreen_spin__uRc40"};